import { NewPasswordModalProps } from 'components/shared/dialogs/NewPasswordModal/NewPasswordModal.types';
import { useTranslator } from 'components/shared/hooks/useTranslator/useTranslator';
import React, { FC } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

export const NewPasswordModal: FC<NewPasswordModalProps> = (props) => {
  const trans = useTranslator();

  return (
    <Dialog disableEscapeKeyDown aria-labelledby="new-password-title" open={props.open}>
      {props.title && <DialogTitle id="new-password-title">{trans(props.title)}</DialogTitle>}
      <DialogContent>
        <DialogContentText>
          {trans(props.message, props.messageValues)} <br />
          {trans('OFFICIALS.NEW_PASSWORD.LOGIN')} <strong>{props.login}</strong> <br />
          {trans('OFFICIALS.NEW_PASSWORD.PASSWORD')} <strong>{props.startPassword}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div></div>
        <Button onClick={props.confirm} color="secondary" variant="contained" data-testid="new-password-close">
          {trans('COMMON.CLOSE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
